module.exports = "/virtual-football-league/img/amblems/left/logos/Fake_Broomwich.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Fake_Broomwich.png
// module id = 2078
// module chunks = 4